import * as React from 'react';
import { ButtonSecondary } from 'ui';
import { CopyLinkProps } from 'app/area/saved-reports/types';
import { copyToClipboard } from 'app/infrastructure/platform/browser';
import styles from './copy-link.scss';

export const CopyLink = (props: CopyLinkProps) => {
  const { translation, initialValue, notification } = props;

  const onClick = () => {
    const copyStatus = copyToClipboard(initialValue);
    if(notification) {
      notification(copyStatus);
    }
  };

  return <div className="form-group">
    <div className="control-label">{translation.link_to_report}</div>
    <div className={`input-wrapper ${styles.box}`}>
      <div className={`${styles.input}`}>
        {initialValue}
      </div>
      <div className={`${styles.button}`}>
        <ButtonSecondary onClick={onClick}>
          {translation.copy}
        </ButtonSecondary>
      </div>
    </div>
  </div>;
};
